<button class="text-small-normal" [ngClass]="{'selected text-small-bold': id === selected}" (click)="onClick()">
  {{ text + (counter ? '(' + counter + ')' : '')}}
</button>
